/**
 * bundle-configurator.js
 *
 * Inizializzazione bundle configurator per il tema Savor 3.5.1.
 * Approccio plain JS senza custom element né private fields:
 * più compatibile e più facile da debuggare.
 */

(function () {
  'use strict';

  // ---------------------------------------------------------------------------
  // Logica per singola istanza di <bundle-configurator>
  // ---------------------------------------------------------------------------

  function setupBundleConfigurator(root) {
    var limit = 6;
    var selections = {};

    // ── 1. Stato iniziale ───────────────────────────────────────────────────

    var checkedRadio = root.querySelector('[data-variant-radio]:checked');
    if (checkedRadio) {
      limit = parseInt(checkedRadio.getAttribute('data-limit'), 10) || 6;
    }

    root.querySelectorAll('[data-product-row]').forEach(function (row) {
      var name = row.getAttribute('data-product-name');
      if (name) selections[name] = 0;
    });

    // ── 2. Listener selezione variante ──────────────────────────────────────
    // Colleziono le label adesso così sono disponibili nella closure di selectVariant

    var variantLabels = Array.from(
      root.querySelectorAll('.bundle-configurator__variant-label')
    );

    variantLabels.forEach(function (label) {
      label.addEventListener('click', function () {
        selectVariant(label);
      });
    });

    // ── 3. Listener bottoni +/- (delegato su root) ──────────────────────────

    root.addEventListener('click', function (e) {
      var target = /** @type {HTMLElement} */ (e.target);

      var minusBtn = target.closest('[data-qty-minus]');
      if (minusBtn) {
        var rowMinus = minusBtn.closest('[data-product-row]');
        if (rowMinus) changeQty(rowMinus, -1);
        return;
      }

      var plusBtn = target.closest('[data-qty-plus]');
      if (plusBtn) {
        var rowPlus = plusBtn.closest('[data-product-row]');
        if (rowPlus) changeQty(rowPlus, 1);
        return;
      }
    });

    // ── 4. Form submit ──────────────────────────────────────────────────────

    var form = root.querySelector('form');
    if (form) {
      form.addEventListener('submit', handleSubmit);
    }

    // ── 5. Render UI iniziale ───────────────────────────────────────────────

    updateUI();

    // ---------------------------------------------------------------------------
    // Funzioni interne
    // ---------------------------------------------------------------------------

    /*function selectVariant(label) {
      var radio = label.querySelector('[data-variant-radio]');
      if (!radio || radio.disabled) return;

      var newLimit = parseInt(radio.getAttribute('data-limit'), 10);
      if (!newLimit) return;

      // Già selezionata — niente da fare
      if (label.classList.contains('is-selected')) return;

      limit = newLimit;

      // Aggiorna is-selected su tutte le label
      variantLabels.forEach(function (l) {
        if (l === label) {
          l.classList.add('is-selected');
        } else {
          l.classList.remove('is-selected');
        }
      });

      // Sync input id nascosto con il nuovo variant id
      var idInput = root.querySelector('input[name="id"]');
      if (idInput) idInput.value = radio.value;

      // Aggiorna prezzo
      var priceEl = root.querySelector('[data-bundle-price]');
      if (priceEl) {
        priceEl.innerHTML = radio.getAttribute('data-price-html') || '';
      }

      // Azzera quantità prodotti
      Object.keys(selections).forEach(function (k) {
        selections[k] = 0;
      });
      root.querySelectorAll('[data-qty-display]').forEach(function (el) {
        el.textContent = '0';
      });

      updateUI();
    }*/

      function selectVariant(label) {
      var radio = label.querySelector('[data-variant-radio]');
      if (!radio || radio.disabled) return;

      var newLimit = parseInt(radio.getAttribute('data-limit'), 10);
      if (!newLimit) return;

      // Già selezionata — niente da fare
      if (label.classList.contains('is-selected')) return;

      limit = newLimit;

      // Aggiorna is-selected su tutte le label
      variantLabels.forEach(function (l) {
        if (l === label) {
          l.classList.add('is-selected');
        } else {
          l.classList.remove('is-selected');
        }
      });

      // Sync input id nascosto con il nuovo variant id
      var idInput = root.querySelector('input[name="id"]');
      if (idInput) idInput.value = radio.value;

      // Aggiorna prezzo
      var priceEl = root.querySelector('[data-bundle-price]');
      if (priceEl) {
        priceEl.innerHTML = radio.getAttribute('data-price-html') || '';
      }

      // ── NUOVO: Aggiorna immagine carosello ──
      var mediaId = radio.getAttribute('data-media-id');
      if (mediaId) {
        // 1. Nascondi tutte le slide presenti nel DOM
        root.querySelectorAll('.bundle-configurator__slide').forEach(function(slide) {
          slide.setAttribute('hidden', '');
          slide.classList.remove('is-active');
        });

        // 2. Cerca la slide associata a questo mediaId e mostrala
        var activeSlide = root.querySelector('.bundle-configurator__slide[data-media-id="' + mediaId + '"]');
        if (activeSlide) {
          activeSlide.removeAttribute('hidden');
          activeSlide.classList.add('is-active');
        }
      }
      // ────────────────────────────────────────

      // Azzera quantità prodotti
      Object.keys(selections).forEach(function (k) {
        selections[k] = 0;
      });
      root.querySelectorAll('[data-qty-display]').forEach(function (el) {
        el.textContent = '0';
      });

      updateUI();
    }

    function changeQty(row, delta) {
      var name = row.getAttribute('data-product-name');
      if (!name) return;

      var current = selections[name] || 0;
      var total = getTotal();
      var next = current + delta;

      if (next < 0) next = 0;
      // Blocca se il bundle è pieno OPPURE se il singolo prodotto raggiunge il limite consentito (es. 5 su 6)
      if (delta > 0 && (total >= limit || next > (limit - 1))) return;

      selections[name] = next;

      var display = row.querySelector('[data-qty-display]');
      if (display) display.textContent = String(next);

      updateUI();
    }

    function getTotal() {
      return Object.keys(selections).reduce(function (sum, k) {
        return sum + (selections[k] || 0);
      }, 0);
    }

    function updateUI() {
      var total = getTotal();

      // Counter
      var counterCurrent = root.querySelector('[data-counter-current]');
      var counterLimit = root.querySelector('[data-counter-limit]');
      if (counterCurrent) counterCurrent.textContent = String(total);
      if (counterLimit) counterLimit.textContent = String(limit);

      // Bottone ATC
      var atcBtn = root.querySelector('[data-add-to-cart]');
      if (atcBtn) atcBtn.disabled = total !== limit;

      // Stato +/- per ogni prodotto
      root.querySelectorAll('[data-product-row]').forEach(function (row) {
        var name = row.getAttribute('data-product-name');
        var qty = selections[name] || 0;
        var minus = row.querySelector('[data-qty-minus]');
        var plus = row.querySelector('[data-qty-plus]');
        if (minus) minus.disabled = qty <= 0;
        // Disabilita il "+" se il bundle è pieno OPPURE se questo specifico prodotto ha raggiunto il massimo (limit - 1)
        if (plus) plus.disabled = (total >= limit) || (qty >= (limit - 1));
      });
    }

    async function handleSubmit(e) {
      e.preventDefault();

      if (getTotal() !== limit) return;

      var idInput = root.querySelector('input[name="id"]');
      if (!idInput || !idInput.value) return;

      var atcBtn = root.querySelector('[data-add-to-cart]');
      var errorEl = root.querySelector('[data-bundle-error]');

      if (atcBtn) {
        atcBtn.disabled = true;
        atcBtn.dataset.loading = 'true';
      }
      if (errorEl) errorEl.setAttribute('hidden', '');

      // Costruisce il payload
      var formData = new FormData();
      formData.set('id', idInput.value);
      formData.set('quantity', '1');

      Object.keys(selections).forEach(function (name) {
        if (selections[name] > 0) {
          formData.set('properties[' + name + ']', String(selections[name]));
        }
      });

      // Raccoglie section IDs per aggiornare il cart drawer
      var sectionIds = [];
      document.querySelectorAll('cart-items-component').forEach(function (el) {
        if (el.dataset && el.dataset.sectionId) {
          sectionIds.push(el.dataset.sectionId);
        }
      });
      if (sectionIds.length) {
        formData.set('sections', sectionIds.join(','));
      }

      try {
        var addResp = await fetch('/cart/add.js', {
          method: 'POST',
          headers: { Accept: 'application/javascript' },
          body: formData,
        });
        var addData = await addResp.json();

        if (addData.status) {
          showError(addData.message || "Errore durante l'aggiunta al carrello.");
          if (atcBtn) {
            atcBtn.disabled = false;
            delete atcBtn.dataset.loading;
          }
          return;
        }

        var cartResp = await fetch('/cart.js');
        var cart = await cartResp.json();

        // Dispatcha cart:update per aprire il cart drawer del tema
        document.dispatchEvent(
          new CustomEvent('cart:update', {
            bubbles: true,
            detail: {
              resource: cart,
              sourceId: root.id || 'bundle-configurator',
              data: {
                source: 'bundle-configurator',
                sections: addData.sections || {},
              },
            },
          })
        );

        // Animazione checkmark identica al bottone ATC del tema
        if (atcBtn) {
          atcBtn.dataset.added = 'true';
          setTimeout(function () {
            delete atcBtn.dataset.added;
          }, 800);
        }
      } catch (err) {
        console.error('[BundleConfigurator]', err);
        showError('Si è verificato un errore. Riprova.');
      } finally {
        if (atcBtn) {
          atcBtn.disabled = getTotal() !== limit;
          delete atcBtn.dataset.loading;
        }
      }
    }

    function showError(msg) {
      var errorEl = root.querySelector('[data-bundle-error]');
      if (!errorEl) return;
      errorEl.textContent = msg;
      errorEl.removeAttribute('hidden');
      setTimeout(function () {
        errorEl.setAttribute('hidden', '');
        errorEl.textContent = '';
      }, 8000);
    }
  }

  // ---------------------------------------------------------------------------
  // Bootstrap — inizializza tutti gli elementi <bundle-configurator> nella pagina
  // ---------------------------------------------------------------------------

  function bootstrap() {
    document.querySelectorAll('bundle-configurator').forEach(function (el) {
      setupBundleConfigurator(el);
    });
  }

  // Con `defer` il DOM è già pronto, ma gestiamo anche il caso senza defer
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', bootstrap);
  } else {
    bootstrap();
  }
})();
